import React, { useState } from 'react';
import useCreateDashboard from 'adapter/in/dashboards/hooks/Dashboard/useCreateDashboard';
import SingleNameInputModal, { CreateNameFormData } from 'adapter/in/common/components/SingleNameInputModal/SingleNameInputModal';
import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';

const gtm = gtmIds.dashboard.createModal;

const useCreateDashboardModal = () => {
    const [showModal, setShowModal] = useState(false);
    const { create, success, error, isLoading } = useCreateDashboard();

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const onInternalSubmit = (data: CreateNameFormData) => {
        create(data.name);
    };

    return {
        modal: (
            <SingleNameInputModal
                title={i18n.t('dashboards.create.modalTitle')}
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                success={success}
                isLoading={isLoading}
                message={i18n.t('dashboards.create.name')}
                error={error}
                placeHolder={i18n.t('dashboards.create.placeholder')}
                handleOnSubmit={onInternalSubmit}
                dataIdContext={{
                    tryAgain: gtm.actions.tryAgain,
                    inputName: gtm.inputName,
                    main: gtm.actions.save,
                    cancel: gtm.actions.cancel,
                }}
            />
        ),
        showModal: () => {
            setShowModal(true);
        },
    };
};

export default useCreateDashboardModal;
